// MATERIAL
import { ButtonBase } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Button = styled(ButtonBase)({
  borderRadius: "50%",
  height: 38,
  width: 38,
});
